// Screen `meeting-type` (owner: scheduling, owner feedback F13): the meeting type editor. `new` starts one.
import { createFileRoute } from '@tanstack/react-router';
import { TypeEditor } from '../../../../features/scheduling/TypeEditor';
import { ModuleGate } from '../../../../shell/ModuleGate';

export const Route = createFileRoute('/_app/meetings/types/$typeId')({
  component: function MeetingTypeRoute() {
    const { typeId } = Route.useParams();
    return (
      <ModuleGate module="meetings">
        <TypeEditor key={typeId} typeId={typeId} />
      </ModuleGate>
    );
  },
});
